<template>
  <div>
    <div class="drawer-header px-15">
      {{indent.order_no}}
    </div>
    <div class="drawer-body p-0">
      <ElTabs class="tab-default tab-sm tab-bg" v-model="tab">
        <Tab-pane :label="$t('INDENT_ACTIONS')" name="actions">
          <div class="tab-content pt-0">
            <div class="content-scroll-inner mx-pd-15" style="width:750px">
              <div class="card-plain">
                <last-mile-actions
                  v-if="action === transporterActions.last_mile_actions"
                  :order="indent"
                  :datePickerFormat="datePickerFormat"
                  :getBackDateConfig="getBackDateConfig"
                  :isShipper="false"
                  :configurations="configurations"
                  :isLrMandatoryForMarkAsDelivered="isLrMandatoryForMarkAsDelivered"
                  @truckin="truckin"
                  @truckout="truckout"
                  @multiple-mark-as-delivered="markDeliver"
                />
              </div>
              <div class="card-plain">
                <container-pickup
                  v-if="showContainerBooked && isMasterIndentActionCompleted"
                  :containerPickupLocation="indent.port_for_container_pickup"
                  @containerPickup="containerPickup"
                  @cancelAction="cancelAction"
                />
              </div>
              <div class="card-plain">
                <reject-indent
                  v-if="enableReject && action === transporterActions.reject"
                  :indent="indent"
                  @rejectIndent="rejectIndent"
                  @cancelAction="cancelAction" />
              </div>
              <div class="card-plain">
                <truck-details
                  v-if="[3, 20].includes(indent.status) && !isReturnIndent
                  && action === transporterActions.assign_truck"
                  header="Assign Truck"
                  :currentOrder="indent"
                  :statusCheck="indent.status"
                  :isDelivered="isDelivered"
                  :hasOverrideTypeWithVehicleConfig="hasOverrideTypeWithVehicleConfig"
                  :vehicleNumberList="vehicleNumberList"
                  :driverNumberList="driverNumberList"
                  :isIndented="isIndented"
                  :inspection="inspection" :inspectionDocs="inspectionDocs"
                  @updateTruck="updateTruck"
                  @cancelAction="cancelAction"
                  @query-driver="getDriverNumberList" />
              </div>
              <div class="card-plain"
                v-if="indent.vehicle && indent.vehicle.number  && !isReturnIndent &&
                  action === transporterActions.vehicle_details">
                <truck-details
                  :header="$t('INDENT_VEHICLE_DETAILS')"
                  :vehicle="indent.vehicle"
                  :driver="indent.driver"
                  :statusCheck="indent.status"
                  :isCancelled="isCancelled"
                  :isDelivered="isDelivered"
                  :isIndented="isIndented"
                  :currentOrder="indent"
                  :hasOverrideTypeWithVehicleConfig="hasOverrideTypeWithVehicleConfig"
                  :vehicleNumberList="vehicleNumberList"
                  :driverNumberList="driverNumberList"
                  :inspection="inspection" :inspectionDocs="inspectionDocs"
                  @updateTruck="updateTruck"
                  @cancelAction="cancelAction"
                  @query-driver="getDriverNumberList" />
                  <VehicleInspection
                    v-if="showInspectionAction"
                    :indent="indent"
                    :attachments="inspectionAttachments"
                    :inspection="inspection" :inspectionDocs="inspectionDocs"
                    :clientId="currentClient.id" :showReject=false
                    :isVehicleInspectionAtSource=true
                    :title="vehicleInspectionTitle"
                    @acceptTruckInspection="acceptTruckInspection"
                    @rejectTruckInspection="rejectTruckInspection"
                    @addAttachments="addAttachments"
                    @removeAttachments="removeAttachments"
                    />
              </div>
              <div class="card-plain bg-grey-lighter">
                <change-trucktype
                  v-if="canChangeTrucktype && !isReturnIndent && !isRoundTrip"
                  :vehicles="indent.contract_vehicles"
                  :currentVehicle="currentVehicle"
                  :canChangeTrucktype="canChangeTrucktype"
                  :canChangeHillyRegion="canChangeHillyRegion"
                  @updateTruckType="updateTruckType"
                  @updateHillyRegion="updateHillyRegion"
                  @cancelAction="cancelAction" />
              </div>
              <div class="card-plain bg-grey-lighter">
                <mark-as-delivered
                  v-if="isDispatched && isGrnEnabled
                  && action === transporterActions.mark_as_delivered"
                  :drops="indent.destinations"
                  :movement="indent.movement"
                  :getBackDateConfig="getBackDateConfig"
                  :dispatchDate="dispatchDate"
                  :sources="indent.sources"
                  :datePickerFormat="datePickerFormat"
                  @markDeliver="markDeliver"
                  @cancelAction="cancelAction" />
              </div>
              <div class="card-plain bg-grey-lighter">
                <truck-in
                  v-if="(action === transporterActions.truck_in) && truckInEnable"
                  :sources="indent.sources"
                  :datePickerFormat="datePickerFormat"
                  @truckIn="data => $emit('truck-in', data)"
                  @cancelAction="cancelAction" />
              </div>
              <div class="card-plain bg-grey-lighter">
                <truck-out
                  v-if="(action === transporterActions.truck_out) && truckOutEnable && truckOutDisableCheck"
                  :source="currentGate"
                  :datePickerFormat="datePickerFormat"
                  :getBackDateConfig="getBackDateConfig"
                  :arrivedDate="truckOutArrivedDate"
                  @truckOut="data => $emit('truck-out', data)"
                  @cancel-action="cancelAction" />
              </div>
              <div class="card-plain">
                <BookingConfirmation
                  :header="$t('INDENT_BOOKING_CONFIRMATION')"
                  v-if="action === transporterActions.booking_confirmation"
                  @confirm-booking="confirmBooking"
                  @cancel-action="cancelAction" />
              </div>
              <div v-if="showNoEvents">
                <div class="paymentempty"></div>
                <div class="emptytext">No Actions Pending</div>
              </div>
              <div class="card-plain bg-grey-lighter">
                <ShipmentDelay
                  v-if="isShipmentDelayEnabled"
                  :order="indent"
                />
              </div>
            </div>
          </div>
        </Tab-pane>
        <Tab-pane :label="trackTabTitle" name="track" v-if="action && trackTabTitle && trackTabPermission">
          <div class="tab-content">
            <Track
              :indent="indent"
              :simTrackingEnabled="simTrackingEnabled"
              :isSimTrackingAllowed="isSimTrackingAllowed"
              :gpsTrackingEnabled="gpsTrackingEnabled"
              :yetToTruckIn="yetToTruckIn"
              :mapConfig="mapConfig"
              :hasDriverAccepted="hasDriverAccepted"
              :appTrackingEnabled="appTrackingEnabled"
              :hyperTrackingEnabled="hyperTrackingEnabled" />
          </div>
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_DETAILS')" name="details">
          <indent-details
            :indent="indent"/>
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_TIMELINE')" name="timeline" v-if="indent.timeline">
          <indent-timeline
            :timeline="indent.timeline"
            :timeFormat="timeFormat" />
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_PTL_GROUPING')" name="ptl_grouping" v-if="isPtlGroupingTabVisible">
          <div class="tab-content">
            <div class="content-scroll-inner mx-pd-15" style="width:750px">
              <PtlGrouping
              :order="indent"
              :selectedAction="action"
              :ptlGroups="ptlGroups ? ptlGroups : []"
              :isEligibleForPtlGrouping="isEligibleForPtlGrouping"
              :materialsInformation="materialsInformation"
              @changeTab="tab = 'actions'"
              @removeIndentGroup="removeIndentGroup"
              @cancelAction="cancelAction"
              />
            </div>
          </div>
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_COMMENTS')" name="comments">
          <div class="tab-content">
          <IndentComments
            v-if="tab === 'comments'"
            :configurations="configurations"
            :indent="indent"
            :formatTime="formatTime" />
          </div>
        </Tab-pane>
        <Tab-pane :label="$t('INDENT_ATTACHMENTS')" v-if="isEximIndent">
          <div class="tab-content">
            <div class="content-scroll-inner mx-pd-15" style="width:800px">
              <EximAttachments
                :selectedIndent="indent"
              />
            </div>
          </div>
        </Tab-pane>
      </ElTabs>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { uniqBy, isEmpty } from 'lodash';
import { movementType as movementListType, orderType } from 'pando-constants';
import { movementTypes, transporterActions, vehicleTypes } from '@/constants/indentConstants';
import IndentDetails from '@/modules/indents/components/details/indentsDetails';
import IndentTimeline from '@/modules/indents/components/details/indentsTimeline';
import IndentComments from '@/modules/indents/components/details/indentcomments';
import EximAttachments from '@/modules/indents/components/details/eximAttachments';
import RejectIndent from '@/modules/indents/components/actions/reject';
import TruckDetails from '@/modules/indents/components/actions/truckDetails';
import PtlGrouping from '@/modules/indents/components/actions/PtlGrouping';
import ChangeTrucktype from '@/modules/indents/components/actions/changeTrucktype';
import MarkAsDelivered from '@/modules/indents/components/actions/markAsDelivered';
import TruckIn from '@/modules/indents/components/actions/truckIn';
import TruckOut from '@/modules/indents/components/actions/truckOut';
import ContainerPickup from '@/modules/indents/components/actions/containerPickup';
import VehicleInspection from '@common/components/indent-actions/VehicleInspection';
import Track from '@/modules/indents/components/actions//Track';
import LastMileActions from '../../../../../../common-v2/components/indent-actions/LastMileActions.vue';
import BookingConfirmation from '@/modules/indents/components/actions/bookingConfirmation';
import ShipmentDelay from '@/modules/indents/components/actions/ShipmentDelay';

export default {
  props: {
    indent: {
      type: Object,
      default: () => {},
    },
    activeTab: {
      type: String,
      default: 'details',
    },
    action: {
      type: String,
    },
    ptlGroups: {
      type: Array,
      default: () => [],
    },
    isEligibleForPtlGrouping: {
      type: Boolean,
      default: false,
    },
    materialsInformation: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    LastMileActions,
    IndentDetails,
    IndentTimeline,
    IndentComments,
    RejectIndent,
    TruckDetails,
    ChangeTrucktype,
    MarkAsDelivered,
    TruckIn,
    TruckOut,
    ContainerPickup,
    EximAttachments,
    VehicleInspection,
    Track,
    PtlGrouping,
    BookingConfirmation,
    ShipmentDelay,
  },
  data() {
    return {
      tab: 'details',
      movementTypes,
      transporterActions,
      vehicleTypes,
      vehicleNumberList: [],
      driverNumberList: [],
      vehicleInspectionTitle: '',
      vehicleInspectionAtDestinationTitle: '',
      inspectionAttachments: [],
      movementListType,
    };
  },
  async created() {
    this.tab = (this.isEligibleForPtlGrouping && (this.$statusUtil.getStatusIds(['indented', 'indent_accepted', 'indent_assign_due',
      'indent_accept_due', 'indent_arrived_due']).includes(this.indent.status) || this.indent.ptl_group_id))
      && (this.indent.movement === 1 || this.indent.movement === 2) && this.action ? 'ptl_grouping' : this.activeTab;
    if ([this.transporterActions.vehicle_details,
      this.transporterActions.assign_truck].includes(this.action)) {
      if (this.hasOverrideTypeWithVehicleConfig && this.indent.order_type === orderType.CONTRACT) {
        await this.getVehicleNumberList();
        await this.getDriverNumberList();
      }
      if (this.showInspectionAction) {
        this.initInspection();
      }
    }
    this.initVehicleInspectionTitle();
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
      configurations: 'app/currentClientConfig',
      currentTransporter: 'app/currentTransporter',
      inspection: 'app/inspection',
      inspectionDocs: 'app/inspectionDocs',
      inspectionAtDestination: 'app/inspectionAtDestination',
      inspectionDocsAtDestination: 'app/inspectionDocsAtDestination',
    }),
    isShipmentDelayEnabled() {
      return this.$hasFeature('is_opted_for_dealer_notifications_via_sdfc') || false;
    },
    isLrMandatoryForMarkAsDelivered() {
      return (this.configurations && this.configurations.is_lr_mandatory_for_mark_as_delivered) || {};
    },
    mapConfig() {
      return (this.configurations && this.configurations.map_configuration);
    },
    datePickerFormat() {
      return (this.configurations && this.configurations.is_datepicker_24H_enabled) ? 'dd-MM-yyyy HH:mm' : 'dd-MM-yyyy hh:mm A';
    },
    timeFormat() {
      return (this.configurations && this.configurations.is_datepicker_24H_enabled) ? 'DD-MM-yyyy | HH:mm' : 'DD-MM-yyyy | hh:mm A';
    },
    isEximIndent() {
      return this.indent && this.indent.exim_type;
    },
    truckOutArrivedDate() {
      return this.indent &&
        this.indent.sources &&
        this.indent.sources[0] &&
        this.indent.sources[0].arrived_at;
    },
    showContainerBooked() {
      return this.indent && this.indent.container_id &&
        [4, 22].includes(this.indent.status) && this.indent.status !== 26 &&
        this.action === transporterActions.container_pickup;
    },
    isReturnIndent() {
      return this.indent.isReturnIndent;
    },
    isRoundTrip() {
      return this.indent.isRoundTrip;
    },
    isContract() {
      return this.indent.order_type === 0;
    },
    isIndented() {
      return this.$statusUtil.getMainStatusId(this.indent.status) === 0;
    },
    isIndentHasHillyRouteCharge() {
      return this.indent && this.indent.destinations.reduce((acc, row) =>
        acc + row.contract.hilly_region_addition_percentage, 0) > 0;
    },
    canChangeHillyRegion() {
      return this.isContract &&
        [0, 21].includes(this.indent.status) &&
        this.isIndentHasHillyRouteCharge;
    },
    canChangeTrucktype() {
      return this.$hasFeature('transporter_change_truck_type') &&
        this.isContract &&
        [0, 21].includes(this.indent.status) &&
        !this.indent.change_truck_type &&
        this.action === transporterActions.change_truck_type;
    },
    getBackDateConfig() {
      return this.configurations && this.configurations.back_date_config ?
        this.configurations.back_date_config : {};
    },
    isDispatched() {
      return this.$statusUtil.isDispatched(this.indent.status);
    },
    isCancelled() {
      return this.$statusUtil.isCancelled(this.indent.status);
    },
    isDelivered() {
      return this.$statusUtil.isDelivered(this.indent.status);
    },
    isGrnEnabled() {
      const movementType = this.movementTypes.find(val => val.id === this.indent.movement);
      return this.configurations && this.configurations.is_grn_enabled_for_transporter &&
        this.configurations.is_grn_enabled_for_transporter[movementType.name.toLowerCase()];
    },
    hasOverrideTypeWithVehicleConfig() {
      return (
        this.configurations &&
        this.configurations.override_type_with_vehicle &&
        this.indent.order_type === orderType.CONTRACT
      ) || false;
    },
    dispatchDate() {
      const maxGateTruckOut = new Date(
        this.$moment.max(
          this.indent.sources.map(_sources => this.$moment(_sources.dispatched_at)),
        ),
      );
      return maxGateTruckOut;
    },
    isMasterIndentActionCompleted() {
      let response = true;
      if ('master_action_completed' in this.indent) {
        // is container Booked status
        response = this.indent.master_action_completed;
      }
      return response;
    },
    currentGate() {
      const currentGate = this.indent.sources.find(gate => gate.arrived_at !== null
        && gate.dispatched_at === null);
      if (this.isStorageLocation) {
        const cG = this.mappedGates;
        if (cG.length) {
          cG[0].gatesName = cG[0].gatesName || cG[0].name || '';
          return cG[0];
        }
        return {};
      }
      if (currentGate) {
        currentGate.gatesName = currentGate.address.name;
      }
      return currentGate;
    },
    mappedGates() {
      const currentGates = this.indent.sources.filter(gate => gate.arrived_at !== null
          && gate.dispatched_at === null);
      const gates = currentGates.map((lgt) => {
        const currentGate = this.$depot.gate(lgt.gate_id, lgt.location_id);
        return {
          ...lgt,
          ...currentGate,
        };
      });
      const { groupedStorage, nonStorageItems } = gates.reduce(
        (acc, item) => {
          if (item.is_storage_location) {
            const locationId = item.location_id || '';
            if (!acc.groupedStorage[locationId]) {
              acc.groupedStorage[locationId] = {
                items: [],
                names: [],
                ids: [],
                lrAvailable: [],
              };
            }
            acc.groupedStorage[locationId].items.push(item);
            acc.groupedStorage[locationId].names.push(item.name || '');
            acc.groupedStorage[locationId].lrAvailable.push(item.lr_available);
            acc.groupedStorage[locationId].ids.push(item.gate_id); // collect storage items
          } else {
            acc.nonStorageItems.push(item); // collect non-storage items
          }
          return acc;
        },
        {
          groupedStorage: {},
          nonStorageItems: [],
        },
      );
        // Combine storage groups per location_id
      const combinedStorageObjects = Object.values(groupedStorage).map(group => ({
        ...group.items[0],
        lr_available: group.lrAvailable.every(Boolean),
        gatesName: `${group.names.join(', ')} ( Storage Location )`,
        combinedStorageGateIds: group.ids,
      }));
      const final = [...combinedStorageObjects, ...nonStorageItems];
      return final;
    },
    isStorageLocation() {
      return this.$hasFeature('enable_storage_location') || false;
    },
    truckOutEnable() {
      const movementType = this.movementTypes.find(val => val.id === this.indent.movement);
      return this.$statusUtil.getStatusIds(['truck_arrived',
        'loading_started', 'loading_ended']).includes(this.indent.status) &&
        (this.configurations && this.configurations.indent_configuration_settings
          && this.configurations.indent_configuration_settings.transporter_truckout
          && this.configurations.indent_configuration_settings.transporter_truckout[movementType.name.toLowerCase()]);
    },
    truckInEnable() {
      const movementType = this.movementTypes.find(val => val.id === this.indent.movement);
      return (this.configurations.indent_configuration_settings.transporter_truckin &&
        this.configurations.indent_configuration_settings.transporter_truckin[movementType.name.toLowerCase()]) &&
        ((this.indent.status === 5 && this.insideGate) ||
          (([4, 22, 24].includes(this.indent.status) &&
            this.$hasFeature('reported_at_depot')))
          || (this.indent.status === 4 && !this.$hasFeature('reported_at_depot')))
        && this.action === transporterActions.truck_in;
    },
    isTruckWithMaterialInvoiceEnabled() {
      const movementType = this.movementTypes.find(val => val.id === this.indent.movement);
      return this.configurations && this.configurations.material_invoice_before_truckout &&
        this.configurations.material_invoice_before_truckout[movementType.name.toLowerCase()];
    },
    truckOutDisableCheck() {
      const currentGate = this.currentGate;
      let gateWiseLrCheck = true;
      let enabledTruckOut = true;
      if (currentGate && this.isTruckWithMaterialInvoiceEnabled) {
        const sourceId = currentGate.gate_id || currentGate.location_id;
        const filterGate = this.indent.source_level_truckout &&
          this.indent.source_level_truckout.find(_source => _source.id === sourceId);
        if (filterGate && !filterGate.has_material_invoice) {
          enabledTruckOut = false;
        }
      }
      if (currentGate && this.$hasFeature('lr_for_truck_out')) {
        const sourceType = currentGate.gate_id ? 'source_gate_id' : 'source_location_id';
        const currentGateType = currentGate.gate_id ? 'gate_id' : 'location_id';
        let consigneeIds = this.indent.destinations
          .filter(consignee => consignee[sourceType] === currentGate[currentGateType])
          .map(consignee => consignee.location_id);
        let consigneeHasLr = uniqBy(this.indent.lorry_receipt, 'destination_location_id')
          .filter(val => consigneeIds.includes(val.destination_location_id));
        if (this.configurations && this.configurations.multi_drop_at_gate_level) {
          consigneeIds = this.indent.destinations
            .filter(consignee => consignee.source_location_id === currentGate.location_id)
            .map((consignee) => {
              if (consignee.gate_id) {
                return `${consignee.location_id}_${consignee.gate_id}`;
              }
              return consignee.location_id;
            });
          consigneeHasLr = uniqBy(this.indent.lorry_receipt,
            item => [item.destination_location_id, item.gate_id]);
        }
        gateWiseLrCheck = currentGate.lr_available || consigneeHasLr.length === [...new Set(consigneeIds)].length;
        if (this.isStorageLocation) {
          const gate = this.mappedGates.find((mGate) => {
            if (mGate.is_storage_location) {
              return mGate.combinedStorageGateIds.includes(currentGate.gate_id);
            }
            return mGate.gate_id.toString() === currentGate.gate_id.toString();
          });
          gateWiseLrCheck = (gate && gate.lr_available) || consigneeHasLr.length === [...new Set(consigneeIds)].length;
        }
      }
      return (enabledTruckOut && gateWiseLrCheck);
    },
    insideGate() {
      const condition =
        this.indent.sources.some(gate => gate.arrived_at !== null && gate.dispatched_at === null);
      return !condition;
    },
    currentVehicle() {
      if (this.indent.vehicle_type_data) {
        return {
          id: this.indent.vehicle_type_data._id,
          name: this.indent.vehicle_type_data.short_form,
        };
      }
      return {};
    },
    enableReject() {
      return this.$statusUtil.getStatusIds(['indented', 'indent_accept_due',
        'truck_change_requested', 'indent_accepted', 'truck_assigned', 'requested', 'reported',
        'truck_rejected']).indexOf(this.indent.status) >= 0 && !this.isReturnIndent;
    },
    showInspectionAction() {
      return this.$hasFeature('truck_inspection');
    },
    /* track related fields */
    gpsTrackingEnabled() {
      return Boolean(this.indent && this.indent.flow.gps_tracking &&
        this.indent.flow.gps_tracking.is_enabled);
    },
    getMovement() {
      if (this.indent) {
        if (this.indent.movement === this.movementListType.RETURNS) {
          return 'Return';
        } else if (this.indent.movement === this.movementListType.INWARD) {
          return 'Vendor';
        } else if (this.indent.movement === this.movementListType.PRIMARY) {
          return 'Primary';
        }
        return 'Secondary';
      }
      return null;
    },
    simTrackingEnabled() {
      return Boolean(this.indent && this.indent.flow.sim_tracking &&
        this.indent.flow.sim_tracking.is_enabled);
    },
    yetToTruckIn() {
      return Boolean(this.indent &&
        this.indent.sources.every(source => source.arrived_at === null));
    },
    hasDriverAccepted() {
      return Boolean(this.indent && this.indent.flow.driver_accepted);
    },
    hyperTrackingEnabled() {
      return !!(this.indent.flow.app_tracking && this.indent.flow.app_tracking.embed_url && this.configurations.mobile_tracking_type === 'HYPERTRACK');
    },
    appTrackingEnabled() {
      return !!(this.indent.flow.app_tracking && this.indent.flow.app_tracking.track_trip_id && this.configurations.mobile_tracking_type === 'APP');
    },
    isSimTrackingAllowed() {
      const movement = this.getMovement.toLowerCase();
      return (this.configurations && this.configurations.track_settings &&
      this.configurations.track_settings[movement] &&
      this.configurations.track_settings[movement].enable_sim_tracking) || false;
    },
    trackTabTitle() {
      if (!this.yetToTruckIn && !this.simTrackingEnabled && this.hasDriverAccepted &&
      this.hyperTrackingEnabled) {
        return 'APP TRACK';
      }
      if (this.gpsTrackingEnabled || (this.isSimTrackingAllowed && this.simTrackingEnabled)
        || (this.appTrackingEnabled && this.hasDriverAccepted && !this.hyperTrackingEnabled)) {
        return 'TRACK';
      }
      return null;
    },
    formatTime() {
      return (this.configurations && this.configurations.is_datepicker_24H_enabled) ? 'HH:mm' : 'hh:mm A';
    },
    isPtlGroupingTabVisible() {
      return this.indent.vehicle_type_data && this.indent.vehicle_type_data
      && this.indent.vehicle_type_data.vehicle_type === vehicleTypes[1].id
      && this.$hasFeature('ptl_grouping')
      && (this.indent.movement === 2 || this.indent.movement === 1);
    },
    trackTabPermission() {
      return this.$hasPermission('view_tracking');
    },
    showNoEvents() {
      return this.$hasFeature('shipment_workflow') && (!this.action || isEmpty(this.action));
    },
  },
  methods: {
    truckin(data) {
      this.$emit('truck-in', data);
    },
    truckout(data) {
      this.$emit('truck-out', data);
    },
    removeIndentGroup(index) {
      if (this.ptlGroups && this.ptlGroups[0].orderData) {
        this.ptlGroups[0].orderData.splice(index, 1);
      }
    },
    initVehicleInspectionTitle() {
      this.vehicleInspectionAtDestinationTitle = this.$t('INDENT_VEHICLE_INSPECTION_AT_DESTINATION');
      if (this.$hasFeature('truck_inspection_at_destination')) {
        this.vehicleInspectionTitle = this.$t('INDENT_VEHICLE_INSPECTION_AT_SOURCE');
      } else {
        this.vehicleInspectionTitle = this.$t('INDENT_VEHICLE_INSPECTION');
      }
    },
    async getVehicleNumberList() {
      try {
        const data = {
          vehicle_type: this.indent.vehicle_type_data._id,
          transporter_id: this.currentTransporter.id,
          is_vehicle_available: true,
          depot_id: this.indent.sources[0].location_id,
        };
        const result = await this.$store.dispatch('indents/getVehicleNumberList', { data });
        if (result && result.data) {
          this.vehicleNumberList = result.data || [];
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async getDriverNumberList(query) {
      try {
        const data = {
          transporter_id: this.currentTransporter.id,
          client_id: this.currentClient.id,
          load_all: true,
        };
        if (query) {
          data.query = query;
        }
        const result = await this.$store.dispatch('indents/getDriverNumberList', { data });
        if (result && result.data) {
          this.driverNumberList = result.data || [];
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    hide(type) {
      this.$set(this, type, false);
    },
    cancelAction() {
      this.$emit('cancelAction');
    },
    acceptIndent() {
      this.$emit('acceptIndent');
    },
    rejectIndent(comments) {
      this.$emit('rejectIndent', comments);
    },
    updateTruck(data, inspectionData = null) {
      const id = this.indent.order_no;
      this.$emit('updateTruck', data, { id, inspectionData });
    },
    updateTruckType(data) {
      this.$emit('updateTruckType', data);
    },
    updateHillyRegion(data) {
      this.$emit('updateHillyRegion', data);
    },
    // updateLR(data) {
    //   this.$emit('updateLR', data);
    // },
    markDeliver(data) {
      this.$emit('markDeliver', data);
    },
    containerPickup(data) {
      this.$emit('containerPickup', data);
    },
    acceptTruckInspection(data, isVehicleInspectionAtSource = true) {
      const id = this.indent.order_no;
      this.$emit('acceptTruckInspection', { id, data }, isVehicleInspectionAtSource);
    },
    rejectTruckInspection(data) {
      const id = this.indent.order_no;
      this.$emit('rejectTruckInspection', { id, data });
    },
    confirmBooking(bookingNumber) {
      this.$emit('confirm-booking', bookingNumber);
    },
    async initInspection() {
      const inspectionObj = this.indent.flow.inspection;
      const clientId = this.indent.client_id;
      if (inspectionObj.attachment_ids && inspectionObj.attachment_ids.length) {
        const ids = inspectionObj.attachment_ids.join(',');
        const result = await this.$store.dispatch('indents/getAttachmentsByIds',
          { ids, client_id: clientId, skipParentCheck: true });
        this.inspectionAttachments = result;
      }
    },
    async addAttachments(file) {
       const formData = new FormData();
      formData.append('attachment', file.raw);
      try {
        const result = await this.$store.dispatch('indents/addAttachment', formData);
        if (result && result.error) {
          this.$errorMessage({ message: result.error || this.$getErr('UPLOAD_FAILS') });
        } else if (result) {
          const inspectionAttachment = {
            attachment_ids: [result.id],
          };
          const response = await this.$store.dispatch('indents/updateInspectionAttachment', {
            orderNo: this.indent.order_no, inspectionAttachment });
          if (response && response.order_no) {
            this.inspectionAttachments.push(result);
            this.$successMessage({ message: this.$t('INDENT_INSPECTION_ACCEPTANCE_TOAST_MSG', { order_number: response.order_no }) });
          } else {
            this.$errorMessage({ message: this.$t('INDENT_INSPECTION_ERROR_MSG', { order_number: response.order_no }) });
          }
        } else {
          this.$error({ message: this.$getErr('UPLOAD_FAILS') });
        }
      } catch (err) {
        const apiError = err && err.data && (err.data.messages || (err.data.errors && err.data.errors[0] && err.data.errors[0].messages));
        this.$error({ message: apiError || this.$getErr('UPLOAD_FAILS'), description: apiError });
      }
    },
    async removeAttachments(file) {
      try {
        const data = {
          orderNo: this.indent.order_no,
          file_id: file.id,
        };
        const response = await this.$store.dispatch('indents/removeInspectionAttachment', data);
        if (response && response.order_no) {
          this.inspectionAttachments = [...this.inspectionAttachments.length ?
            this.inspectionAttachments.filter(attachment =>
              attachment.id !== file.id) : []];
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
